export default function loadingPage() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#fff'
    }}>
      <p>Loading...</p>
    </div>
  );
}
